import { render, staticRenderFns } from "./trafficOpen.vue?vue&type=template&id=be810eee&scoped=true&"
import script from "./trafficOpen.vue?vue&type=script&lang=js&"
export * from "./trafficOpen.vue?vue&type=script&lang=js&"
import style0 from "./trafficOpen.vue?vue&type=style&index=0&id=be810eee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be810eee",
  null
  
)

export default component.exports